import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import ContactUs from "../components/organisms/ContactUs"
import LearnMore from "../components/organisms/LearnMore"
import ClutchSlider from "../components/organisms/ClutchSlider"
import CSSlider from "../components/organisms/CaseStudySlider"
import AboutUs from "../components/organisms/AboutUs"
import Clients from "../components/organisms/Clients"
import SEO from "../components/seo"
import HomeHero from "../components/organisms/HomeHero"
import DigitsRow from "../components/organisms/DigitsRow"
import Services from "../components/organisms/Services"
import VideoComponent from "../components/organisms/VideoComponent"

const query = graphql`
  {
    allStrapiMembers(sort: { order: ASC, fields: order }) {
      nodes {
        animoji {
          firstFrame {
            childImageSharp {
              original {
                src
              }
            }
          }
        }
        jobTitle
        imageSmall {
          childImageSharp {
            fluid(maxWidth: 156, quality: 100) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        name
      }
    }
    strapiHomepage {
      digitsRow {
        digit
        description
      }
      metaTags {
        description
        title
        ogImage {
          childImageSharp {
            fluid(maxWidth: 1200, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      beforeFooter {
        text
      }
      caseStudies {
        button {
          link
          title
        }
        id
        title {
          subtitle
          title
        }
        image {
          childImageSharp {
            fluid(maxWidth: 1176, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      clutchReviews {
        id
        review
        reviewRate
        reviewerJob
        reviewerName
      }
      contactUs {
        title {
          subtitle
          title
        }
        buttons {
          link
          title
        }
      }
      hero {
        header {
          id
          subtitle
          title
        }
      }
      whoWeAre {
        button {
          link
          title
        }
        header {
          subtitle
          title
        }
        paragraph
        howWeWorkIcons {
          url
        }
      }
      productsServices {
        header {
          title
          subtitle
        }
        listOfProducts {
          description
          image {
            childImageSharp {
              fluid(maxWidth: 1176, quality: 100) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
          }
          name
        }
        servicesList {
          title
          leftText
          rightText
        }
      }
    }
    strapiOptions {
      clutchReview
      numberOfReviews
    }
  }
`

const IndexPage = props => {
  const data = useStaticQuery(query)
  const beforeFooter = data.strapiHomepage.beforeFooter
  const caseStudies = data.strapiHomepage.caseStudies
  const clutchReviews = data.strapiHomepage.clutchReviews
  const contactUs = data.strapiHomepage.contactUs
  const whoWeAre = data.strapiHomepage.whoWeAre
  const productsServices = data.strapiHomepage.productsServices
  const clutchRating = data.strapiOptions.clutchReview
  const numberOfReviews = data.strapiOptions.numberOfReviews
  const members = data.allStrapiMembers.nodes
  const seo = data.strapiHomepage.metaTags
  const digitsRowData = data.strapiHomepage.digitsRow
  const video = {
    video: {
      videoLink: "",
      haveBottomOverlay: true,
    },
  }
  const [isDesktop, setIsDesktop] = useState(true)

  function checkDevice() {
    if (window.innerWidth > 768) {
      setIsDesktop(true)
    } else {
      setIsDesktop(false)
    }
  }

  useEffect(() => {
    checkDevice()
  }, [])

  useEffect(() => {
    window.addEventListener("resize", checkDevice)
    return () => {
      window.removeEventListener("resize", checkDevice)
    }
  })

  return (
    <>
      <Layout className="homepage">
        <SEO
          image={seo.ogImage?.childImageSharp?.fluid?.src}
          title={seo.title}
          description={seo.description}
        />
        <HomeHero
          // title={hero.header.title}
          title="America’s most trusted offshore web design agency"
          paragraph="Our customers love to work with us"
          showClutchRev
          numberOfReviews={numberOfReviews}
          clutchRating={clutchRating}
        />
        <DigitsRow data={digitsRowData} />
        <VideoComponent />
        <AboutUs
          title={whoWeAre.header.title}
          subtitle={whoWeAre.header.subtitle}
          paragraph={whoWeAre.paragraph}
          icons={whoWeAre.howWeWorkIcons}
          members={members}
          button={whoWeAre.button}
          isDesktop={isDesktop}
        />

        <CSSlider caseStudies={caseStudies} isDesktop={isDesktop} />
        <Services
          items={productsServices.servicesList}
          title={productsServices.header.title}
          subtitle={productsServices.header.subtitle}
          isDesktop={isDesktop}
        />
        <Clients />
        <ClutchSlider clutchReviews={clutchReviews} />
        <ContactUs
          title={contactUs.title.title}
          subtitle={contactUs.title.subtitle}
          contactUsLink={contactUs.buttons[0].link}
          contactUsTitle={contactUs.buttons[0].title}
          callUsLink={contactUs.buttons[1].link}
          callUsTitle={contactUs.buttons[1].title}
        />
        <LearnMore linkTitle="Learn more about us" to="/about/">
          {beforeFooter.text}
        </LearnMore>
      </Layout>
    </>
  )
}
export default IndexPage
